import axios from "axios";
// import logger from "./logService";
// import { toast } from "react-toastify";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;
axios.defaults.headers.common ={HTTP_X_FORWARDED_HOST: 'https://bhuvan-staging1.nrsc.gov.in'}
axios.interceptors.response.use(null, (error) => {
  const expectedError =
    error.response &&
    error.response.status >= 400 &&
    error.response.status < 500;
  if (!expectedError) {
    //Sentry.captureException(error);
    console.log(error)
    // logger.log(error);
    // toast.error("An unexpected error ocurred.");
  }
  return Promise.reject(error);
});
// function setPassport(passport) {
//   axios.defaults.headers.common = { HTTP_X_FORWARDED_HOST: 'bhuvan-staging1.nrsc.gov.in'};
// }

export default {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
//   setPassport,
};